export const paths = {
  root: '/',
  configurator: '/insurance-check',
  schedule: '/schedule',
}
